<template>
  <BaseCard :class="{ quiet: isLoading }" :has-header-padding="false" color-scheme="white">
    <template #card-header>
      <slot name="head" />
      <ul class="actions">
        <transition name="fade">
          <li v-if="isLoading">
            <a>
              <i :class="{ 'zmdi-hc-spin': isLoading }" class="zmdi zmdi-refresh" />
            </a>
          </li>
        </transition>
        <li v-if="hasDownloadListener || hasDownloadDropdownOptionsSlot">
          <a
            v-if="hasDownloadListener && !hasDownloadDropdownOptionsSlot"
            href="#"
            @click="$emit('download')"
          >
            <i class="zmdi zmdi-download" />
          </a>
          <PopperIcon v-if="hasDownloadDropdownOptionsSlot" icon="zmdi-download">
            <ul class="base-dropdown-menu">
              <slot name="download-dropdown-options" />
            </ul>
          </PopperIcon>
        </li>
        <slot name="dropdown">
          <li v-if="hasDropdownOptionsSlot" class="dropdown">
            <PopperIcon icon="zmdi-more-vert">
              <ul class="base-dropdown-menu">
                <slot name="dropdown-options" />
              </ul>
            </PopperIcon>
          </li>
        </slot>
        <li v-if="$slots.help">
          <PopperIconHelp><slot name="help" /></PopperIconHelp>
        </li>
        <slot name="action-buttons" />
      </ul>
    </template>
    <slot name="body" />
    <slot name="foot" />
  </BaseCard>
</template>

<script>
import PopperIconHelp from '@/components/PopperIconHelp.vue'
import PopperIcon from '@/components/PopperIcon.vue'
import BaseCard from '@/components/BaseCard.vue'

export default {
  components: { BaseCard, PopperIcon, PopperIconHelp },
  props: { isLoading: { type: Boolean, default: false } },
  computed: {
    hasDownloadListener() {
      return this.$attrs && this.$attrs.onDownload
    },
    hasDropdownOptionsSlot() {
      return !!this.$slots['dropdown-options']
    },
    hasDownloadDropdownOptionsSlot() {
      return !!this.$slots['download-dropdown-options']
    },
  },
}
</script>

<style scoped>
.card {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.card .card-header .actions {
  z-index: inherit !important;
}
</style>
